import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useParallaxParameters } from './hooks/useParallaxParameters';

interface IAdBannerMicrofrontendParallaxContainerProps {
  manifest: IMicrofrontendManifest;
  position: number;
  isNewbuilding: boolean;
  onStub?: () => void;
  onError?: () => void;
  onClose?: () => void;
}

/**
 * Place-контейнер параллакс-баннера: поставляет параметры места и рендерит generic-контейнер.
 */
export const AdBannerMicrofrontendParallaxContainer: React.FC<IAdBannerMicrofrontendParallaxContainerProps> = ({
  manifest,
  position,
  isNewbuilding,
  onStub,
  onError,
  onClose,
}) => {
  const parameters = useParallaxParameters({ position, isNewbuilding });

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );
};
